import type * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCombinantGenomesUsergroupsQueryVariables = Types.Exact<{
  organismId: Types.Scalars['Long']['input'];
}>;


export type GetCombinantGenomesUsergroupsQuery = { organism: { id: number, userGroups: Array<{ id: number, name: string } | null> | null } };

export type UserGroupFragment = { id: number, name: string };

export type CreateVirtualGenomeMutationVariables = Types.Exact<{
  virtualGenomeInput: Types.InputMaybe<Types.InputVirtualGenomeInput>;
}>;


export type CreateVirtualGenomeMutation = { createVirtualGenome: { id: number, identifier: string | null, name: string | null, species: { id: number, name: string } | null } | null };

export type GetGenomeStatisticsQueryVariables = Types.Exact<{
  genomeId: Types.Scalars['Long']['input'];
}>;


export type GetGenomeStatisticsQuery = { organism: { genomeStatistics: { genomeSize: number | null, contigCount: number | null, orfsCount: number | null, geneCount: number | null, transcriptsCount: number | null, proteinsCount: number | null, ecProteinAssignmentsCount: number | null, ecCoverage: number | null, genesLinkedTranscriptsCount: number | null, genesLinkedProteinsCount: number | null, flagCount: number | null } | null } };

export type GetGenomeProteinStatisticsQueryVariables = Types.Exact<{
  genomeId: Types.Scalars['Long']['input'];
}>;


export type GetGenomeProteinStatisticsQuery = { organism: { genomeStatistics: { proteinsCount: number | null, aaFeaturesCount: Array<{ count: number, associatedProteins: number, featureTypeName: string } | null> | null } | null } };

export type GetGenomeNucleotideStatisticsQueryVariables = Types.Exact<{
  genomeId: Types.Scalars['Long']['input'];
}>;


export type GetGenomeNucleotideStatisticsQuery = { organism: { genomeStatistics: { markersCount: Array<{ count: number | null, markerTypeName: string | null } | null> | null, nuFeaturesCount: Array<{ count: number | null, featureTypeName: string | null } | null> | null } | null } };

export type GetGenomeVirtualGenomesStatisticsQueryVariables = Types.Exact<{
  genomeId: Types.Scalars['Long']['input'];
}>;


export type GetGenomeVirtualGenomesStatisticsQuery = { organism: { virtualGenomes: Array<{ id: number, sequencingType: string | null, name: string | null, type: string | null, description: string | null, hidden: boolean, groupType: string, species: { name: string } | null }>, components: Array<{ id: number, sequencingType: string | null, groupType: string, name: string | null, type: string | null, description: string | null, hidden: boolean, species: { name: string } | null }> } };

export type GetNucleotideFeatureSelectorStatisticsQueryVariables = Types.Exact<{
  genomeId: Types.Scalars['Long']['input'];
}>;


export type GetNucleotideFeatureSelectorStatisticsQuery = { organism: { genomeStatistics: { markersCount: Array<{ markerTypeId: number | null, markerTypeName: string | null } | null> | null, nuFeaturesCount: Array<{ featureTypeId: number | null, featureTypeName: string | null, featureTypeColor: string | null } | null> | null } | null } };

export type GetContigFeatureSelectorStatisticsQueryVariables = Types.Exact<{
  contigId: Types.Scalars['Long']['input'];
}>;


export type GetContigFeatureSelectorStatisticsQuery = { contig: { contigStatistics: { markersCount: Array<{ markerTypeId: number | null, markerTypeName: string | null } | null> | null, nuFeaturesCount: Array<{ featureTypeId: number | null, featureTypeName: string | null, featureTypeColor: string | null } | null> | null } } | null };

export const UserGroupFragmentDoc = gql`
    fragment UserGroup on UserGroup {
  id
  name
}
    `;
export const GetCombinantGenomesUsergroupsDocument = gql`
    query getCombinantGenomesUsergroups($organismId: Long!) {
  organism(organismId: $organismId) {
    id
    userGroups {
      ...UserGroup
    }
  }
}
    ${UserGroupFragmentDoc}`;

/**
 * __useGetCombinantGenomesUsergroupsQuery__
 *
 * To run a query within a React component, call `useGetCombinantGenomesUsergroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCombinantGenomesUsergroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCombinantGenomesUsergroupsQuery({
 *   variables: {
 *      organismId: // value for 'organismId'
 *   },
 * });
 */
export function useGetCombinantGenomesUsergroupsQuery(baseOptions: Apollo.QueryHookOptions<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables> & ({ variables: GetCombinantGenomesUsergroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables>(GetCombinantGenomesUsergroupsDocument, options);
      }
export function useGetCombinantGenomesUsergroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables>(GetCombinantGenomesUsergroupsDocument, options);
        }
export function useGetCombinantGenomesUsergroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables>(GetCombinantGenomesUsergroupsDocument, options);
        }
export type GetCombinantGenomesUsergroupsQueryHookResult = ReturnType<typeof useGetCombinantGenomesUsergroupsQuery>;
export type GetCombinantGenomesUsergroupsLazyQueryHookResult = ReturnType<typeof useGetCombinantGenomesUsergroupsLazyQuery>;
export type GetCombinantGenomesUsergroupsSuspenseQueryHookResult = ReturnType<typeof useGetCombinantGenomesUsergroupsSuspenseQuery>;
export type GetCombinantGenomesUsergroupsQueryResult = Apollo.QueryResult<GetCombinantGenomesUsergroupsQuery, GetCombinantGenomesUsergroupsQueryVariables>;
export const CreateVirtualGenomeDocument = gql`
    mutation createVirtualGenome($virtualGenomeInput: InputVirtualGenomeInput) {
  createVirtualGenome(virtualGenomeInput: $virtualGenomeInput) {
    id
    identifier
    name
    species {
      id
      name
    }
  }
}
    `;
export type CreateVirtualGenomeMutationFn = Apollo.MutationFunction<CreateVirtualGenomeMutation, CreateVirtualGenomeMutationVariables>;

/**
 * __useCreateVirtualGenomeMutation__
 *
 * To run a mutation, you first call `useCreateVirtualGenomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVirtualGenomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVirtualGenomeMutation, { data, loading, error }] = useCreateVirtualGenomeMutation({
 *   variables: {
 *      virtualGenomeInput: // value for 'virtualGenomeInput'
 *   },
 * });
 */
export function useCreateVirtualGenomeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVirtualGenomeMutation, CreateVirtualGenomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVirtualGenomeMutation, CreateVirtualGenomeMutationVariables>(CreateVirtualGenomeDocument, options);
      }
export type CreateVirtualGenomeMutationHookResult = ReturnType<typeof useCreateVirtualGenomeMutation>;
export type CreateVirtualGenomeMutationResult = Apollo.MutationResult<CreateVirtualGenomeMutation>;
export type CreateVirtualGenomeMutationOptions = Apollo.BaseMutationOptions<CreateVirtualGenomeMutation, CreateVirtualGenomeMutationVariables>;
export const GetGenomeStatisticsDocument = gql`
    query getGenomeStatistics($genomeId: Long!) {
  organism(organismId: $genomeId) {
    genomeStatistics {
      genomeSize
      contigCount
      orfsCount
      geneCount
      transcriptsCount
      proteinsCount
      ecProteinAssignmentsCount
      ecCoverage
      genesLinkedTranscriptsCount
      genesLinkedProteinsCount
      flagCount
    }
  }
}
    `;

/**
 * __useGetGenomeStatisticsQuery__
 *
 * To run a query within a React component, call `useGetGenomeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenomeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenomeStatisticsQuery({
 *   variables: {
 *      genomeId: // value for 'genomeId'
 *   },
 * });
 */
export function useGetGenomeStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables> & ({ variables: GetGenomeStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>(GetGenomeStatisticsDocument, options);
      }
export function useGetGenomeStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>(GetGenomeStatisticsDocument, options);
        }
export function useGetGenomeStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>(GetGenomeStatisticsDocument, options);
        }
export type GetGenomeStatisticsQueryHookResult = ReturnType<typeof useGetGenomeStatisticsQuery>;
export type GetGenomeStatisticsLazyQueryHookResult = ReturnType<typeof useGetGenomeStatisticsLazyQuery>;
export type GetGenomeStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetGenomeStatisticsSuspenseQuery>;
export type GetGenomeStatisticsQueryResult = Apollo.QueryResult<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>;
export const GetGenomeProteinStatisticsDocument = gql`
    query getGenomeProteinStatistics($genomeId: Long!) {
  organism(organismId: $genomeId) {
    genomeStatistics {
      aaFeaturesCount {
        count
        associatedProteins
        featureTypeName
      }
      proteinsCount
    }
  }
}
    `;

/**
 * __useGetGenomeProteinStatisticsQuery__
 *
 * To run a query within a React component, call `useGetGenomeProteinStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenomeProteinStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenomeProteinStatisticsQuery({
 *   variables: {
 *      genomeId: // value for 'genomeId'
 *   },
 * });
 */
export function useGetGenomeProteinStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables> & ({ variables: GetGenomeProteinStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables>(GetGenomeProteinStatisticsDocument, options);
      }
export function useGetGenomeProteinStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables>(GetGenomeProteinStatisticsDocument, options);
        }
export function useGetGenomeProteinStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables>(GetGenomeProteinStatisticsDocument, options);
        }
export type GetGenomeProteinStatisticsQueryHookResult = ReturnType<typeof useGetGenomeProteinStatisticsQuery>;
export type GetGenomeProteinStatisticsLazyQueryHookResult = ReturnType<typeof useGetGenomeProteinStatisticsLazyQuery>;
export type GetGenomeProteinStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetGenomeProteinStatisticsSuspenseQuery>;
export type GetGenomeProteinStatisticsQueryResult = Apollo.QueryResult<GetGenomeProteinStatisticsQuery, GetGenomeProteinStatisticsQueryVariables>;
export const GetGenomeNucleotideStatisticsDocument = gql`
    query getGenomeNucleotideStatistics($genomeId: Long!) {
  organism(organismId: $genomeId) {
    genomeStatistics {
      markersCount {
        count
        markerTypeName
      }
      nuFeaturesCount {
        count
        featureTypeName
      }
    }
  }
}
    `;

/**
 * __useGetGenomeNucleotideStatisticsQuery__
 *
 * To run a query within a React component, call `useGetGenomeNucleotideStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenomeNucleotideStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenomeNucleotideStatisticsQuery({
 *   variables: {
 *      genomeId: // value for 'genomeId'
 *   },
 * });
 */
export function useGetGenomeNucleotideStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables> & ({ variables: GetGenomeNucleotideStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables>(GetGenomeNucleotideStatisticsDocument, options);
      }
export function useGetGenomeNucleotideStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables>(GetGenomeNucleotideStatisticsDocument, options);
        }
export function useGetGenomeNucleotideStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables>(GetGenomeNucleotideStatisticsDocument, options);
        }
export type GetGenomeNucleotideStatisticsQueryHookResult = ReturnType<typeof useGetGenomeNucleotideStatisticsQuery>;
export type GetGenomeNucleotideStatisticsLazyQueryHookResult = ReturnType<typeof useGetGenomeNucleotideStatisticsLazyQuery>;
export type GetGenomeNucleotideStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetGenomeNucleotideStatisticsSuspenseQuery>;
export type GetGenomeNucleotideStatisticsQueryResult = Apollo.QueryResult<GetGenomeNucleotideStatisticsQuery, GetGenomeNucleotideStatisticsQueryVariables>;
export const GetGenomeVirtualGenomesStatisticsDocument = gql`
    query getGenomeVirtualGenomesStatistics($genomeId: Long!) {
  organism(organismId: $genomeId) {
    virtualGenomes {
      id
      sequencingType
      id
      name
      type
      description
      hidden
      species {
        name
      }
      groupType
    }
    components {
      id
      sequencingType
      groupType
      id
      name
      type
      description
      hidden
      species {
        name
      }
    }
  }
}
    `;

/**
 * __useGetGenomeVirtualGenomesStatisticsQuery__
 *
 * To run a query within a React component, call `useGetGenomeVirtualGenomesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenomeVirtualGenomesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenomeVirtualGenomesStatisticsQuery({
 *   variables: {
 *      genomeId: // value for 'genomeId'
 *   },
 * });
 */
export function useGetGenomeVirtualGenomesStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables> & ({ variables: GetGenomeVirtualGenomesStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables>(GetGenomeVirtualGenomesStatisticsDocument, options);
      }
export function useGetGenomeVirtualGenomesStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables>(GetGenomeVirtualGenomesStatisticsDocument, options);
        }
export function useGetGenomeVirtualGenomesStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables>(GetGenomeVirtualGenomesStatisticsDocument, options);
        }
export type GetGenomeVirtualGenomesStatisticsQueryHookResult = ReturnType<typeof useGetGenomeVirtualGenomesStatisticsQuery>;
export type GetGenomeVirtualGenomesStatisticsLazyQueryHookResult = ReturnType<typeof useGetGenomeVirtualGenomesStatisticsLazyQuery>;
export type GetGenomeVirtualGenomesStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetGenomeVirtualGenomesStatisticsSuspenseQuery>;
export type GetGenomeVirtualGenomesStatisticsQueryResult = Apollo.QueryResult<GetGenomeVirtualGenomesStatisticsQuery, GetGenomeVirtualGenomesStatisticsQueryVariables>;
export const GetNucleotideFeatureSelectorStatisticsDocument = gql`
    query getNucleotideFeatureSelectorStatistics($genomeId: Long!) {
  organism(organismId: $genomeId) {
    genomeStatistics {
      markersCount {
        markerTypeId
        markerTypeName
      }
      nuFeaturesCount {
        featureTypeId
        featureTypeName
        featureTypeColor
      }
    }
  }
}
    `;

/**
 * __useGetNucleotideFeatureSelectorStatisticsQuery__
 *
 * To run a query within a React component, call `useGetNucleotideFeatureSelectorStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNucleotideFeatureSelectorStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNucleotideFeatureSelectorStatisticsQuery({
 *   variables: {
 *      genomeId: // value for 'genomeId'
 *   },
 * });
 */
export function useGetNucleotideFeatureSelectorStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables> & ({ variables: GetNucleotideFeatureSelectorStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables>(GetNucleotideFeatureSelectorStatisticsDocument, options);
      }
export function useGetNucleotideFeatureSelectorStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables>(GetNucleotideFeatureSelectorStatisticsDocument, options);
        }
export function useGetNucleotideFeatureSelectorStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables>(GetNucleotideFeatureSelectorStatisticsDocument, options);
        }
export type GetNucleotideFeatureSelectorStatisticsQueryHookResult = ReturnType<typeof useGetNucleotideFeatureSelectorStatisticsQuery>;
export type GetNucleotideFeatureSelectorStatisticsLazyQueryHookResult = ReturnType<typeof useGetNucleotideFeatureSelectorStatisticsLazyQuery>;
export type GetNucleotideFeatureSelectorStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetNucleotideFeatureSelectorStatisticsSuspenseQuery>;
export type GetNucleotideFeatureSelectorStatisticsQueryResult = Apollo.QueryResult<GetNucleotideFeatureSelectorStatisticsQuery, GetNucleotideFeatureSelectorStatisticsQueryVariables>;
export const GetContigFeatureSelectorStatisticsDocument = gql`
    query getContigFeatureSelectorStatistics($contigId: Long!) {
  contig(contigId: $contigId) {
    contigStatistics {
      markersCount {
        markerTypeId
        markerTypeName
      }
      nuFeaturesCount {
        featureTypeId
        featureTypeName
        featureTypeColor
      }
    }
  }
}
    `;

/**
 * __useGetContigFeatureSelectorStatisticsQuery__
 *
 * To run a query within a React component, call `useGetContigFeatureSelectorStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContigFeatureSelectorStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContigFeatureSelectorStatisticsQuery({
 *   variables: {
 *      contigId: // value for 'contigId'
 *   },
 * });
 */
export function useGetContigFeatureSelectorStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables> & ({ variables: GetContigFeatureSelectorStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables>(GetContigFeatureSelectorStatisticsDocument, options);
      }
export function useGetContigFeatureSelectorStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables>(GetContigFeatureSelectorStatisticsDocument, options);
        }
export function useGetContigFeatureSelectorStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables>(GetContigFeatureSelectorStatisticsDocument, options);
        }
export type GetContigFeatureSelectorStatisticsQueryHookResult = ReturnType<typeof useGetContigFeatureSelectorStatisticsQuery>;
export type GetContigFeatureSelectorStatisticsLazyQueryHookResult = ReturnType<typeof useGetContigFeatureSelectorStatisticsLazyQuery>;
export type GetContigFeatureSelectorStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetContigFeatureSelectorStatisticsSuspenseQuery>;
export type GetContigFeatureSelectorStatisticsQueryResult = Apollo.QueryResult<GetContigFeatureSelectorStatisticsQuery, GetContigFeatureSelectorStatisticsQueryVariables>;